import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppInitializer } from './components/AppInitializer';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AnalysisFlowProvider } from './contexts/AnalysisFlowContext';
import { AuthProvider } from './contexts/AuthContext';

// 懒加载页面组件以减少初始bundle大小
const HomePage = lazy(() => import('./pages/HomePage').then(m => ({ default: m.HomePage })));
const BirthInfoPage = lazy(() => import('./pages/BirthInfoPage').then(m => ({ default: m.BirthInfoPage })));
const LoadingPage = lazy(() => import('./pages/LoadingPage').then(m => ({ default: m.LoadingPage })));
const ResultsPage = lazy(() => import('./pages/ResultsPage').then(m => ({ default: m.ResultsPage })));
const MyReadingsPage = lazy(() => import('./pages/MyReadingsPage').then(m => ({ default: m.MyReadingsPage })));
const DashboardPage = lazy(() => import('./pages/DashboardPage').then(m => ({ default: m.DashboardPage })));
const AuthCallback = lazy(() => import('./pages/AuthCallback').then(m => ({ default: m.AuthCallback })));

function App() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const isDark = localStorage.getItem('darkMode') === 'true';
    setDarkMode(isDark);
    if (isDark) {
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode.toString());
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <AppInitializer>
      <AuthProvider>
        <AnalysisFlowProvider>
          <Router>
            <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'dark' : ''}`}>
              <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
              <ErrorBoundary>
                <Suspense fallback={
                  <div className="min-h-screen flex items-center justify-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
                  </div>
                }>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/birth-info" element={<BirthInfoPage />} />
                    <Route path="/loading" element={<LoadingPage />} />
                    <Route path="/results" element={<ResultsPage />} />
                    <Route path="/my-readings" element={<MyReadingsPage />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                  </Routes>
                </Suspense>
              </ErrorBoundary>
              <Footer />
            </div>
          </Router>
        </AnalysisFlowProvider>
      </AuthProvider>
    </AppInitializer>
  );
}

export default App;